<template>
  <div class="wrapper-sofia" :class="{'no-permissions': !sofiaEnabled}">
    <div v-if="sofiaEnabled">
      <div id="sofia-container" v-once />
      <sofia-filter-modals-vue
        ref="sofia-filter-modals"
        @confirm_filter_values="confirmFilterValues"
        :sofia-filters="sofiaFilters"
      />
    </div>
    <sofia-premium-form-vue v-else info_link_position="body" ref="premium_form"/>
  </div>
</template>

<script>
import mixins from 'common/mixins.js'

const WHITELISTED_AI_WRITE_ACTIONS = [
  'summarize_text',
  'query_document',
  'summarize_legal_text',
  'extract_main_ideas',
  'schematize_text',
  'extract_related_ideas',
  'generate_conceptual_map',
  'strategic_legal_text',
  'legal_analysis_evidence'
]

export default {
  name: 'sofia-wrapper-vue',
  components: {
    'sofia-premium-form-vue': () => import(
      /* webpackChunkName: "[request]" */ 'components/sofia/PremiumForm'
    ),
    'sofia-filter-modals-vue': () => import(
      /* webpackChunkName: "[request]" */ 'components/sofia/SofiaFilterModals'
    )
  },
  mixins: [mixins.requests, mixins.translate],
  props: {
    favourite_id: String,
    domain: String,
    sofiaFilters: { type: Array, default: () => [] },
    userPermissionModules: { type: Array, default: () => [] },
    defaultTab: { type: String, default: null }
  },
  computed: {
    sofiaEnabled() {
      return this.userPermissionModules.includes('sofia')
    },
    enabled_favourites() {
      return this.favourite_id != ''
    },
    favourite_params() {
      return this.enabled_favourites ? { fav: this.favourite_id } : {}
    },
    filteredSofiaActions() {
      return gon.sofia.ai_write_actions.filter(
        (action) => WHITELISTED_AI_WRITE_ACTIONS.includes(action)
      )
    }
  },
  methods: {
    buildSofia() {
      return new Sofia({
        config: {
          textModes: [Sofia.constants.TEXT_MODE.SELECTION, Sofia.constants.TEXT_MODE.COMPLETE],
          closeButton: { show: false, position: 'left' },
          expandButton: { show: false, position: 'left' },
          events: {
            closeButton: this.close_button_handler,
            expandButton: this.expand_button_handler,
            document: this.document_handler,
            concept: this.concept_handler,
            openFilterModal: this.openFilterModal
          },
          lang: this.$language,
          tolgeo: gon.app_tolgeo,
          paisiso: gon.paisiso,
          defaultMessage: 'Seleccione texto para analizar',
          automaticWarning: true,
          getTokenFunction: this.getToken,
          favourites: this.enabled_favourites,
          formsFirst: false,
          endpoint: this.$sofia_service_url + '/',
          initialDomain: this.domain,
          aiWrite: {
            actions: this.filteredSofiaActions,
            applyResult: {
              translation: this.t('components.sofia.wrapper.copy_to_clipboard'),
              clean: false
            }
          },
          sofiaFilters: this.sofiaFilters,
          showModelSelector: gon.sofia.show_model_selector
        },
        buttons: [],
        defaultTab: this.defaultTab,
        expanded: true,
        permissions: this.userPermissionModules
      })
    },
    render_sofia() {
      this.sofia.render('sofia-container');
    },
    async analyze(text, quotes_id, reject_ids) {
      this.scrollToTop()
      this.sofia.eventBus.publish('ai-analyze:executed')
      await this.sofia.analyze(text,'',quotes_id,reject_ids)
      this.scrollToTop()
    },
    close_button_handler() {},
    expand_button_handler() {},
    document_handler(docid) {
      var event = new CustomEvent('document-quick-view', { detail: { documentId: docid } })
      window.parent.document.dispatchEvent(event)
    },
    concept_handler() {},
    async getToken() {
      return this.getServiceToken('sofia', {
        permissions: this.userPermissionModules,
        ...this.favourite_params
      })
    },
    scrollToTop() {
      document.body.scrollIntoView({behavior: "smooth"})
    },
    sofiaAiWriteExecuteAction(key, params) {
      this.sofia.eventBus.publish('ai-write:action-executed', key, params)
    },
    sofiaChangeSelection(status) {
      this.sofia.eventBus.publish('selection-changed', status)
    },
    openFilterModal(selectedModal) {
      this.$refs['sofia-filter-modals'].showModal(
        selectedModal.tipoid,
        selectedModal.field
      )
    },
    confirmFilterValues(tipoid, name, selectedValues) {
      this.sofia.setSofiaFilterValues(tipoid, name, selectedValues)
    }
  },
  mounted() {
    this.sofia = this.buildSofia()
    if (this.sofiaEnabled) this.render_sofia()

    document.addEventListener("sofia-analyze", (event) => {
      this.lastAnalysisData = {
        text: event.detail.text,
        quotes_id: event.detail.quotes_id,
        document_ids: [event.detail.document_id]
      }
      this.analyze(event.detail.text, event.detail.quotes_id, [event.detail.document_id])
    })

    this.sofia.eventBus.subscribe('sofia:modal-cleared',(tipoid, field) => {
      this.$refs['sofia-filter-modals'].clearModal(tipoid, field)
    })

    document.addEventListener('sofia:selection-changed', (event) => {
      this.sofiaChangeSelection(event.detail.status)
    })

    this.sofia.eventBus.subscribe('ai-write:action-requested', (key, params) => {
      document.dispatchEvent(new CustomEvent('sofia:ai-write:action-requested', {
        detail: { key: key, params: params }
      }))
    })

    this.sofia.eventBus.subscribe('sofia:analysis-domain-changed', () => {
      this.analyze(
        this.lastAnalysisData.text,
        this.lastAnalysisData.quotes_id,
        this.lastAnalysisData.document_ids
      )
    })

    document.addEventListener('sofia:ai-write:action-executed', (event) => {
      this.sofiaAiWriteExecuteAction(event.detail.key, event.detail.params)
    })

    this.sofia.eventBus.subscribe('ai-write:result-applied', (text) => {
      document.dispatchEvent(new CustomEvent('sofia:ai-write:result-applied', {
        detail: { text: text }
      }))
    })
  }
}
</script>
